import React from 'react';

const Shimmer = ({
  width,
  height,
  borderRadius,
}: {
  width?: string;
  height?: string;
  borderRadius?: string;
}) => {
  const style = {
    width: width || '100%',
    height: height || '20px',
    borderRadius: borderRadius || '0.375rem', // Tailwind's default rounded-md
  };

  return (
    <div className="bg-gray-100 relative overflow-hidden" style={style}>
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/70 to-transparent animate-shimmer"></div>
    </div>
  );
};

export default Shimmer;
